<template>
    <div class="container">
        <v-title :breadcrumb="{label: 'Dashboard', route: {name: 'dashboard'}, root: true}">
            Dashboard
            <div slot="actions" v-if="$auth.dashboard.isAllowed">
                <v-range-picker
                    data-cy="Date range picker"
                    class="display-inline-block inline-m"
                    :value="period"
                    @input="changePeriod"/>
                <v-icon-button class="has-tooltip has-tooltip-right-edge" @click="resetTiles" data-tooltip="Restore Metrics">
                    <v-icon icon="reset"></v-icon>
                </v-icon-button>
            </div>
        </v-title>
        <template v-if="$auth.dashboard.isAllowed">
            <segments/>
            <metrics :period="period"/>
            <v-no-content data-cy="No content - unavailable"  v-if="hasServerError">
                <span slot="title">Temporarily Unavailable</span>
                <span slot="description">Your dashboard data is temporarily unavailable. Please contact us with any questions.</span>
            </v-no-content>
        </template>
        <v-no-content data-cy="No content - restricted" v-else>
            <span slot="title">Restricted Access</span>
            <span slot="description">Your dashboard access is restricted. Contact your administrator if you need access to this information.</span>
        </v-no-content>
    </div>
</template>

<script>
    import vTitle from '@/components/v-title';
    import vNoContent from '@/components/v-no-content';
    import {vIcon, vIconButton} from '@/components/form';
    import vRangePicker from '@/components/calendar/v-range-picker';
    import calendarPresets, {calendarPresetsPeriods} from '@/components/calendar/calendar-presets';
    import DashboardBus from './components/dashboard-bus';
    import Metrics from './components/metrics';
    import Segments from './components/segments';

    /**
     * Dashboard contains the {@link segments} and {@link metrics} components. Metrics is
     * the one that calls the API with segments initially created from Segments (possibly pulled
     * from user's profile.)
     *
     * @see segments
     * @see metrics
     */
    export default {
        name: 'dashboard',
        components: {
            vTitle,
            Metrics,
            Segments,
            vNoContent,
            vRangePicker,
            vIconButton,
            vIcon,
        },
        data() {
            return {
                hasServerError: false,
                period: calendarPresetsPeriods[calendarPresets.last30Days](this.$tz()),
            };
        },
        created() {
            DashboardBus.$on('server-error', this.showServerError);
        },
        methods: {
            showServerError() {
                this.hasServerError = true;
            },
            /**
             * Change the date period from which to pull metrics.
             * @param data Object representing a start and end date
             */
            changePeriod(data) {
                this.period = data;
                this.$nextTick(() => DashboardBus.$emit('period-change'));
            },
            /**
             * Emit an event which will trigger a child component (metrics.vue) to reset metric
             * tile display data.
             */
            resetTiles() {
                DashboardBus.$emit('reset-tiles');
            },
        },
        beforeDestroy() {
            DashboardBus.$off('server-error');
            this.$store.dispatch('dashboard/reset');
        },
    };
</script>

<docs>
    ```jsx
    <dashboard/>
    ```
</docs>
